export default {"src":"/_next/static/media/IMG.7922502f.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};